import jQuery from "jquery"
import jqUaAddcls from "@/assets/js/functions/jquery.ua_addclass.js"
import jsRdmRange from "@/assets/js/functions/getRandomRange.js"
import jsImgLink from "@/assets/js/functions/setImageLink.js"
import jsStg from "@/assets/js/functions/class_localStorage.js"
import ie from "@/assets/js/functions/checkIE.js";
// import jqFixed from "@/assets/js/functions/class_jqFixedWindow.js"
var ls = new jsStg.jsLocalStorage();
// var fw = new jqFixed.jqfixedWindow();

import EnglishQuestionComponent from '@/views/exam/english-question.vue';
import EnglishAnswerComponent from '@/views/exam/english-answer.vue';
import MathQuestionComponent from '@/views/exam/math-question.vue';
import MathAnswerComponent from '@/views/exam/math-answer.vue';
import scratchpad from '@/components/scratchpad.vue';

import answerSelectionMixins from "./mixin/answerSelectionMixins"

export default {
	name: "exam",
	props: {
		title: String,
		title_html: String,
		title_id: String,
		ls_key: String,
		jsonObj: Object,
		SettingObj: Object,
	},
	components: { 
		EnglishAnswerComponent, 
		MathAnswerComponent, 
		EnglishQuestionComponent,
		MathQuestionComponent,
		scratchpad 
	},
	mixins: [answerSelectionMixins],
	data: function() {
		return {
			qAry: [],
			incorrectAry: [], // 不正解情報配列
			bookmarkAry: [], // 問題登録情報配列
			currentPage: 0,
			bool: {answer: false, active_expl: false, active_next :false, active_submit : false, explanation: false, howto: false, confirm: false, correct: false, txtaligntop: false, show: false},
			data: {answers: [], images :[], answer: "", select_answer: 0, explanation: "", howto: "", bookmark: false, check: false, index: 0},
			continue_order: false, // 
			height: {header: 0, text: 0, text_top: 0, text_bottom: 0, answer: 0, answer_bottom: 0, btn_wrap: 0, footer: 0},
			bgcolors: {
				text: {color: this.SettingObj.bgcolors.text},
				size : {fontSize : '20px', lineHeight : '30px'},
				header: {background: this.SettingObj.bgcolors.header},
				footer: {background: this.SettingObj.bgcolors.footer},
				title: {background: this.SettingObj.bgcolors.title},
				border_text: {border: this.SettingObj.bgcolors.border_text},
				border_answer: {border: this.SettingObj.bgcolors.border_answer},
				button_heavy: {background: this.SettingObj.bgcolors.button_heavy, borderBottom: this.SettingObj.bgcolors.button_heavy_thick},
				button_light: {background: this.SettingObj.bgcolors.button_light, borderBottom: this.SettingObj.bgcolors.button_light_thick},
			},
			multipleAnswers: [],
			multipleAnswerInputs: [],
			correctAnswer : [],
			fixedAnswers : [],
			multipleQuestionStylings: {
				verticalAlign: true,
				fontSize: "20px",
				color: this.SettingObj.bgcolors.border_text,
			},
			blankStylings: {
				border: '2px solid rgba(0,153,220,1)', 
				minWidth: '100px', 
				minHeight: '30px', 
				textAlign: 'center', 
				borderRadius: '3px', 
				margin: '0',
				display: 'inline-block',
			},
			isIE : false,
			isLandscape : false,
			ieStylings : {
				bottom : '70px'
			},
			showScratch: false,
			hasImage : false
		}
	},
	created: function() {
		var i, j, firstHit;
		var ls_data = ls.getStorageJson(this.ls_key);
		var current_hd = ls_data.current_head_id;
		var current_id = ls_data.saveAry[current_hd].current;
		// 最初の起動時に、解答数と正解数を成績状況のキャッシュ用に初期化
		if (!ls_data.saveAry[current_hd].cache.q) {
			ls_data.saveAry[current_hd].cache.q = 1;
			ls.setStorageJson(this.ls_key, ls_data);
		}
		if (this.data.check) {
			if (!ls_data.saveAry[current_hd].cache.a) {
				ls_data.saveAry[current_hd].cache.a = 1;
			}
		}

		// 最初の起動時に、選択した単元のJSONデータ内出題数を基準に「bookmarkAry」「correctAry」の各Obj配列を初期化
		if (!ls_data.saveAry[current_hd].bookmarkAry.length && !ls_data.saveAry[current_hd].correctAry.length) {
			for (i = 0; i < this.jsonObj.qAry[current_hd].questions.length; i++) {
				const id = this.jsonObj.qAry[current_hd].questions[i].id;
				ls_data.saveAry[current_hd].bookmarkAry[id] = {
					id: id,
					bool: false,
				};
				ls_data.saveAry[current_hd].correctAry[id] = {
					id: id,
					bool: false,
					select: null,
				};
			}
		}

		// 各問題の出題時に登録状態と正解チェック状態を取得して状態復帰
		if (ls_data.saveAry[current_hd].bookmarkAry[current_id]) {
			this.data.bookmark = ls_data.saveAry[current_hd].bookmarkAry[current_id].bool;
		}
		if (ls_data.saveAry[current_hd].correctAry[current_id]) {
			this.data.check = ls_data.saveAry[current_hd].correctAry[current_id].bool;
		}

		// 続きから解く場合は this.currentPage を保存されているID番号へ変更
		if (ls_data.continueBool) {
				this.currentPage = ls_data.saveAry[current_hd].current;
		}

		// シャッフル出題を選択している場合の処理
		if (ls_data.randomBool) {

			this.data.index = ls_data.saveAry[current_hd].index; // 通し番号を読み込む
			// 続きから解く場合で前回解答時がシャッフル出題でない場合、残りの問題IDをもとにシャッフル配列を再作成し、差分で上書きする処理
			if (ls_data.continueBool && !ls_data.randomBool_before) {
				var rangeAry_id = [];
				var rangeAry_rdm = [];
				var qAry = this.jsonObj.qAry[current_hd].questions;
				var save_id = ls_data.saveAry[current_hd].current;
				var firstRdmId = 0;
				firstHit = false;

				for (i = 0; i < qAry.length; i++) {
					if (save_id <= qAry[i].id) {
						if (!firstHit) {
							firstRdmId = qAry[i].id;
							rangeAry_id.push(firstRdmId);
							firstHit = true;
						} else {
							rangeAry_rdm.push(qAry[i].id);
							rangeAry_id.push(qAry[i].id);
						}
					}
				}
				rangeAry_rdm = jsRdmRange.getRandomRange(rangeAry_rdm.length, rangeAry_rdm.length, rangeAry_rdm);
				rangeAry_rdm.unshift(firstRdmId);

				for (i = 0; i < rangeAry_id.length; i++) {
					ls_data.saveAry[current_hd].randomAry[rangeAry_id[i]].id = rangeAry_id[i];
					ls_data.saveAry[current_hd].randomAry[rangeAry_id[i]].random = rangeAry_rdm[i];
				}
			}

			const rdmid = (!ls_data.continueBool)? // 最初から or 続きからでID取得を分岐
				ls_data.saveAry[current_hd].randomAry[current_id].random : ls_data.saveAry[current_hd].current;
			this.currentPage = rdmid;
			ls_data.saveAry[current_hd].current = rdmid;
			this.data.bookmark = ls_data.saveAry[current_hd].bookmarkAry[rdmid].bool;
			this.data.check = ls_data.saveAry[current_hd].correctAry[rdmid].bool;
			this.data.continue_order = true;
			ls_data.randomBool_before = true;

		} else { // シャッフル出題でない場合の処理

			// 続きから解く場合で前回解答時がシャッフル出題だった場合、残りの未解答問題IDをもとに新規配列を作成し出題実行する処理
			if (ls_data.continueBool && ls_data.randomBool_before === true) {
				const current = ls_data.saveAry[current_hd].current;
				const randomAry = ls_data.saveAry[current_hd].randomAry;

				firstHit = false;
				var firstHitObj = {};
				var re_correctAry = [];
				var current_bool = false;
				for (i = 0; i < randomAry.length; i++) {
					if (randomAry[i].random === current) { // 前回のシャッフル出題時のカレント出題Obj配列（要素はひとつのみ）
						for (j = 0; j < ls_data.saveAry[current_hd].correctAry.length; j++) {
							if (current === ls_data.saveAry[current_hd].correctAry[j].id) {
								firstHitObj = {
									id: ls_data.saveAry[current_hd].correctAry[j].id,
									bool: ls_data.saveAry[current_hd].correctAry[j].bool,
									select: ls_data.saveAry[current_hd].correctAry[j].select,
								};
								break;
							}
						}
						firstHit = true;
						continue;
					}
					if (firstHit) { // 前回シャッフル出題時のカレント出題IDの次以降の出題Obj配列
						for (j = 0; j < ls_data.saveAry[current_hd].correctAry.length; j++) {
							if (randomAry[i].random === ls_data.saveAry[current_hd].correctAry[j].id) {
								current_bool = ls_data.saveAry[current_hd].correctAry[j].bool
								break;
							}
						}
						re_correctAry.push({
							id: randomAry[i].random,
							bool: current_bool,
						});
					}
				}
				// 前回シャッフル出題時に未解答分が複数ある場合はカレント出題IDを先頭に、以降のシャッフル出題状態を降順ソートして配列どうしを結合
				if (!re_correctAry) {
					re_correctAry.push(firstHitObj);

				} else {
					re_correctAry.sort(function(a, b) {
						if(a.id < b.id) return -1;
						if(a.id > b.id) return 1;
						return 0;
					});
					re_correctAry.unshift(firstHitObj);
				}

				var correctAry = ls_data.saveAry[current_hd].correctAry;
				for (i = 0; i < re_correctAry.length; i++) {
					for (j = 0; j < correctAry.length; j++) {
						if (re_correctAry[i].id === correctAry[j].id) {
							correctAry.splice(j, 1);
							continue;
						}
					}
				}
				ls_data.saveAry[current_hd].correctAry = correctAry.concat(re_correctAry);

				// bookmarkAryの配列順を続きから解く場合で前回解答時がシャッフル出題だった場合のcorrectAryに揃える
				var re_bookmarkAry = [];
				correctAry = ls_data.saveAry[current_hd].correctAry;
				for (i = 0; i < correctAry.length; i++) {
					for (j = 0; j < ls_data.saveAry[current_hd].bookmarkAry.length; j++) {
						if (correctAry[i].id === ls_data.saveAry[current_hd].bookmarkAry[j].id) {
							re_bookmarkAry[i] = ls_data.saveAry[current_hd].bookmarkAry[j];
						}
					}
				}
				ls_data.saveAry[current_hd].bookmarkAry = re_bookmarkAry;
			}
			this.data.continue_order = true;
			ls_data.randomBool_before = false;
		}

		// 不正解の問題だけ解く場合の初期処理
		if (ls_data.incorrectBool) {
			const correctAry = ls_data.saveAry[current_hd].correctAry;
			firstHit = false;
			if (correctAry) {
				for (i = 0; i < correctAry.length; i++) {
					const id = correctAry[i].id;
					if (!correctAry[id].bool) {
						// 最初のヒット時のみ、不正解問題ID番号へ変更しつつ正解チェックを復帰
						if (!firstHit) {
							this.currentPage = ls_data.continueBool ? this.currentPage : id;
							this.data.check = ls_data.saveAry[current_hd].correctAry[id].bool;
							firstHit = true;
						}
						this.incorrectAry.push(id); // 不正解情報配列へPush
					}
				}
			}
		}
		// 登録した問題を解く場合の初期処理
		if (ls_data.bookmarkBool) {
			const bookmarkAry = ls_data.saveAry[current_hd].bookmarkAry;
			firstHit = false;
			if (bookmarkAry) {
				for (i = 0; i < bookmarkAry.length; i++) {
					const id = bookmarkAry[i].id;
					if (bookmarkAry[id].bool) {
						// 最初のヒット時のみ、登録問題ID番号へ変更しつつ登録チェックを復帰
						if (!firstHit) {
							this.currentPage = ls_data.continueBool ? this.currentPage : id;
							this.data.bookmark = ls_data.saveAry[current_hd].bookmarkAry[id].bool;
							this.data.check = ls_data.saveAry[current_hd].correctAry[id].bool;
							firstHit = true;
						}
						this.bookmarkAry.push(id); // 登録問題配列へPush
					}
				}
			}
		}

		ls.setStorageJson(this.ls_key, ls_data);
		return;
	},
	mounted: function() {
		// ユーザーエージェントよりclass属性（ua_sp、ua_tb、ua_pc）を追加
		
		jqUaAddcls.ua_addclass();
	
		// examFlameHeightメソッド用にdataへキャッシュ
		var obj = this.uiHeightObj();
		this.height.header = obj.header;
		this.height.currentinfo_wrap = obj.currentinfo_wrap;
		this.height.text_top = obj.text_top;
		this.height.text_bottom = obj.text_bottom;
		this.height.answer_bottom = obj.answer_bottom;
		this.height.btn_wrap = obj.btn_wrap;
		this.height.footer = obj.footer;
	
		if(ie.detectIEEdge()){
			this.isIE = true;
		}
	},
	updated: function() {
	
		var obj = this.uiHeightObj();
		this.height.header = obj.header;
		this.height.currentinfo_wrap = obj.currentinfo_wrap;
		this.height.text_top = obj.text_top;
		this.height.text_bottom = obj.text_bottom;
		this.height.answer_bottom = obj.answer_bottom;
		this.height.btn_wrap = obj.btn_wrap;
		this.height.footer = obj.footer;
		// ウインドウのリサイズ・回転に応じた出題表示の高さを自動調整（jQuery）
		jQuery(window).resize({uiHeightObj: this.uiHeightObj, text: this.height.text, answer: this.height.answer}, function(e) {
			obj = e.data.uiHeightObj();
			var h = jQuery(window).height(); // 画面全体の高さを取得
			var uiHeight = obj.header+obj.currentinfo_wrap+obj.text_top+obj.text_bottom+obj.answer_bottom+obj.btn_wrap+obj.footer;

			jQuery(".exam .content .text").css("height", ((h-uiHeight)*e.data.text)+"px");
			jQuery(".exam .answer_before, .exam .answer_after, .exam .answer_btn").css("height", ((h-uiHeight)*e.data.answer)+"px");
			return;
		});
	},
	computed: {
		activeRandom: function () {
			var ls_data = ls.getStorageJson(this.ls_key);
			return ls_data.randomBool;
		},
		Qs: function() {
			var i, j;
			var ls_data = ls.getStorageJson(this.ls_key);
			var current_hd = ls_data.current_head_id;
			var qAry = this.jsonObj.qAry[current_hd]; // 選択中単元の出題Objを代入
			// 「続きから解く」用に表示開始ページを再定義
			var current_id = 0;
			if (ls_data.continueBool) {
				ls_data.saveAry[current_hd].cache.q = 0;
				ls_data.saveAry[current_hd].cache.a = 0;
			// 「不正解の問題だけ解く」用に表示開始ページを再定義
			} else if (ls_data.incorrectBool) {
				const correctAry = ls_data.saveAry[current_hd].correctAry;
				for (i = 0; i < correctAry.length; i++) {
					const id = correctAry[i].id;
					if (correctAry[id].bool === false) {
						current_id = id;
						break;
					}
				}

			// 「登録した問題を解く」用に表示開始ページを再定義
			} else if (ls_data.bookmarkBool) {
				const bookmarkAry = ls_data.saveAry[current_hd].bookmarkAry;
				for (i = 0; i < bookmarkAry.length; i++) {
					const id = bookmarkAry[i].id;
					if (bookmarkAry[id].bool) {
						current_id = id;
						break;
					}
				}
			}

			/* eslint-disable */
			var qLength = qAry.questions.length; // 出題する総数

			// 各出題方法の最終出題IDを定義
			var final_id;
			if (ls_data.incorrectBool) { // 間違った問題を解く
				final_id = this.incorrectAry[this.incorrectAry.length-1];
				if(ls_data.continueBool) {
					//this.currentPage = this.incorrectAry[this.currentPage];
				}
				// qLength = final_id + 1
				// if (ls_data.randomBool) { 
				// 	var randomAry = ls_data.saveAry[current_hd].randomAry;
				// 	final_id = randomAry[qLength-1].random;
				// }

			} else if (ls_data.bookmarkBool) { // 登録した問題を解く
				final_id = this.bookmarkAry[this.bookmarkAry.length-1];
				if(ls_data.continueBool) {
					//this.currentPage = this.bookmarkAry[this.currentPage];
				}
				// qLength = final_id + 1
				// if (ls_data.randomBool) { 
				// 	var randomAry = ls_data.saveAry[current_hd].randomAry;
				// 	final_id = randomAry[qLength-1].random;
				// }

			} else if (ls_data.randomBool) { // シャッフル出題
				var randomAry = ls_data.saveAry[current_hd].randomAry;
				final_id = randomAry[qLength-1].random;
			} else { // その他の出題方法 // final_id = qAry.questions[qLength-1].id;
				for (i = 0; i < qAry.questions.length; i++) {
					if (qAry.questions[i].id === ls_data.saveAry[current_hd].correctAry[ls_data.saveAry[current_hd].correctAry.length-1].id) {
						final_id = qAry.questions[i].id;
						break;
					}
				}
			}
			var set_qid;
			this.qAry = [];
			for (i = current_id; i < ls_data.saveAry[current_hd].correctAry.length; i++) {
				var qid = (!ls_data.randomBool)? 
					ls_data.saveAry[current_hd].correctAry[i].id : ls_data.saveAry[current_hd].randomAry[i].random;

				// ループカウンタ基準ではなく設問IDを基準にした配列番号を取得
				for (j = 0; j < qAry.questions.length; j++) {
					if (qAry.questions[j].id === qid) {
						set_qid = j;
						break;
					}
				}

				// JSON内の画像ファイル名記述（【…】の半角文字）からリンクパスを取得し置換
				qAry.questions[set_qid] = jsImgLink.setImageLink(qAry.questions[set_qid]);

				// Shuffled Answers
				const _contents = {
					...qAry.questions[set_qid],
					shuffledAnswers: this.shuffleAnswers(qAry.questions[set_qid].answers)
				}
				
				// プロパティを追加しながら出題表示用Objを初期化
				this.qAry[qid] = {
					head_id: qAry.head_id,
					header: qAry.header,
					set_qid: set_qid,
					contents: _contents,
					amount: qLength,
					final_id: final_id,
				};
			}
			/* eslint-enable */
			//console.log(this.qAry)
			return this.qAry;
		}
	},
	methods: {
		// 出題画面内各UIのheightをObjで返す（jQuery関数）
		uiHeightObj: function() {
			return {
				header: jQuery(".exam header").outerHeight(), // ヘッダー
				currentinfo_wrap: jQuery(".exam .currentinfo_wrap").outerHeight(), // 問題数表示
				text_top: parseInt(jQuery(".exam .text").css("margin-top"), 10), // 出題表示上マージン
				text_bottom: parseInt(jQuery(".exam .text").css("margin-bottom"), 10), // 出題表示下マージン
				answer_bottom: parseInt(jQuery(".exam .question_wrap > div, .exam .question_wrap > ul").css("margin-bottom"), 10), // 解答表示下マージン
				btn_wrap: jQuery(".exam .btn_wrap").outerHeight(), // 下部ボタンエリア
				footer: jQuery("footer").outerHeight(), // フッター
			};
		},
		// ウインドウの初期サイズに応じた出題表示の高さを初期調整
		examFlameHeight: function(type, flameHeight) {
			// 引数「type」ごとに問題文・解答文の高さを定義
			this.orientationCheck();
			//if(!this.isLandscape){
				if (type === "text") {
					this.height.text = flameHeight;
				} else if (type === "answer") {
					this.height.answer = flameHeight;
				}
				var h = window.innerHeight;
				const uiHeight = this.height.header+this.height.currentinfo_wrap+this.height.text_top+this.height.text_bottom+this.height.answer_bottom+this.height.btn_wrap+this.height.footer;
				return {height: ((h-uiHeight)*flameHeight)+"px"};
			//}
		},
		orientationCheck : function(){
			this.isLandscape = ((window.innerWidth > window.innerHeight) && typeof window.orientation !== "undefined") ? true : false;
			window.addEventListener("resize", function() {
				this.isLandscape = ((window.innerWidth > window.innerHeight) && typeof window.orientation !== "undefined") ? true : false;
				
			});
		},
		// 出題通し番号をカウントする処理（シャッフル出題用）
		addIndex: function() {
			var ls_data = ls.getStorageJson(this.ls_key);
			var current_hd = ls_data.current_head_id;
			this.data.index = ls_data.saveAry[current_hd].index+1;
			ls_data.saveAry[current_hd].index = this.data.index;
			ls.setStorageJson(this.ls_key, ls_data);

			return this.data.index;
		},
		// 選択肢ボタンイベント
		selectItem: function(currentPage, item, correct) {
			var ls_data = ls.getStorageJson(this.ls_key);
			var current_hd = ls_data.current_head_id;
			this.data.select_answer = item;

			// 選択した選択肢番号を登録
			ls_data.saveAry[current_hd].correctAry[currentPage].select = item;

			// 正解した時の処理
			if (item === correct) {
				this.bool.correct = true;
				this.bool.answer = true;
				ls_data.saveAry[current_hd].correctAry[currentPage].bool = true;
			}

			// 解説ボタンは答えをみた後でアクティブに
			if (!this.bool.active_expl) {
				this.bool.active_expl = true;
			}

			ls.setStorageJson(this.ls_key, ls_data);
			return;
		},
		// 答えをみるボタンイベント
		viewAnswer: function(currentAnswer) {
			let explanation = this.Qs[this.currentPage].contents.explanation;
			if (!this.bool.answer) {
				// drill.json内でテキスト一文字目が「▼」の場合、テキスト位置を天地センターではなく天揃えにする
				if (currentAnswer.match(/^▼+/g)) {
					currentAnswer = currentAnswer.replace(/^▼+/g, ""); //「▼」は不要なため削除
					this.bool.txtaligntop = true;
				}
				this.data.answer = currentAnswer;
				this.bool.answer = true;
			}
			if (!this.bool.active_expl && explanation != "") {
				this.bool.active_expl = true; // 解説ボタンは答えをみた後でアクティブに
			}

		},
		// 問題登録チェックイベント
		checkBookmark: function(currentPage) {
			this.data.bookmark = !this.data.bookmark;
			var ls_data = ls.getStorageJson(this.ls_key);
			var current_hd = ls_data.current_head_id;
			const qAry = this.jsonObj.qAry;
			const allGenre = ls_data.saveAry.length - 1;

			// 最初の保存時は初期化する
			if (!ls_data.saveAry[current_hd].bookmarkAry) {
				ls_data.saveAry[current_hd].bookmarkAry = [{}];
			}
			// 問題登録の連想配列を生成
			ls_data.saveAry[current_hd].bookmarkAry[currentPage] = {
				id: currentPage,
				bool: (this.data.bookmark)? true : false,
			};

			// IF head_id === 3 IT MEANS IT IS 'ALL GENRE' SO UPDATE THE BASE GENRE TOO
			var q_index;
			if(current_hd === allGenre) {
				var base_genre = qAry.find(function(it){
					return it.questions.find(function(q){
						return q.gid === currentPage
					})
				})

				var base_head_id = base_genre.head_id

				if (!ls_data.saveAry[base_head_id].bookmarkAry.length) {
					ls_data.saveAry[base_head_id].bookmarkAry = base_genre.questions.map(function(it){
						return {
							id: it.id,
							bool: false,
						}
					});
				}

				if (!ls_data.saveAry[base_head_id].correctAry.length) {
					ls_data.saveAry[base_head_id].correctAry = base_genre.questions.map(function(it){
						return {
							id: it.id,
							bool: false,
							select: null,
						}
					});
				}

				q_index = base_genre.questions.findIndex(function(it){
					return it.gid === currentPage
				})
					
				// 問題登録の連想配列を生成
				ls_data.saveAry[base_head_id].bookmarkAry[q_index] = {
					id: q_index,
					bool: (this.data.bookmark) ? true : false,
				};
			} else {
				const all_genres = qAry[allGenre]
				const questions = qAry[current_hd].questions
				
				// 最初の保存時は初期化する
				if (!ls_data.saveAry[allGenre].bookmarkAry.length) {
					ls_data.saveAry[allGenre].bookmarkAry = all_genres.questions.map(function(it){
						return {
							id: it.id,
							bool: false,
						}
					});
				}

				if (!ls_data.saveAry[allGenre].correctAry.length) {
					ls_data.saveAry[allGenre].correctAry = all_genres.questions.map(function(it){
						return {
							id: it.id,
							bool: false,
							select: null,
						}
					});
				}

				q_index = questions[currentPage].gid

				// 問題登録の連想配列を生成
				ls_data.saveAry[allGenre].bookmarkAry[q_index] = {
					id: q_index,
					bool: (this.data.bookmark) ? true : false,
				};
			}
			
			ls.setStorageJson(this.ls_key, ls_data);
			return;
		},
		// 正解チェックイベント
		checkCorrect: function(currentPage) {
			
			this.data.check = !this.data.check;
			var ls_data = ls.getStorageJson(this.ls_key);
			var current_hd = ls_data.current_head_id;

			// 正解チェックの可否で正解・不正解状態を登録
			ls_data.saveAry[current_hd].correctAry[currentPage].bool = (this.data.check)? true : false;

			ls.setStorageJson(this.ls_key, ls_data);
			return;
		},
		checkMultipleCorrect: function(currentPage, isCorrect) {

			this.data.check = !this.data.check;
			var ls_data = ls.getStorageJson(this.ls_key);
			var current_hd = ls_data.current_head_id;

			// 正解チェックの可否で正解・不正解状態を登録
			ls_data.saveAry[current_hd].correctAry[currentPage].bool = isCorrect;
			
			//console.log(this.multipleAnswers)

			ls.setStorageJson(this.ls_key, ls_data);
			return;
		},
		// 次へボタンイベント
		nextPage: function() {
			var ls_data = ls.getStorageJson(this.ls_key);
			var current_hd = ls_data.current_head_id;
			var i;
			var cache_q;

			// 選択した出題方法によって次のページ情報を分岐代入する
			if (ls_data.incorrectBool) { // 不正解の問題だけ解く
				if(ls_data.randomBool) {
					cache_q = ls_data.saveAry[current_hd].cache.q;
					this.currentPage = ls_data.saveAry[current_hd].randomAry[cache_q].random;
					
				} else {
					for (i = 0; i < this.incorrectAry.length; i++) {
						if(this.currentPage === this.incorrectAry[this.incorrectAry.length - 1]) {
							break;
						}
						
						if (this.currentPage === this.incorrectAry[i]) {
							this.currentPage = this.incorrectAry[i+1];
							break;
						}
					}
				}

			} else if (ls_data.bookmarkBool) { // 登録した問題を解く
				if(ls_data.randomBool) {
					cache_q = ls_data.saveAry[current_hd].cache.q;
					this.currentPage = ls_data.saveAry[current_hd].randomAry[cache_q].random;
				} else {
					for (i = 0; i < this.bookmarkAry.length; i++) {
						if(this.currentPage === this.bookmarkAry[this.bookmarkAry.length - 1]) {
							break;
						}

						if (this.currentPage === this.bookmarkAry[i]) {
							this.currentPage = this.bookmarkAry[i+1];
							break;
						}
					}
				}

			} else if (ls_data.randomBool) { // シャッフル出題時
				cache_q = ls_data.saveAry[current_hd].cache.q;
				this.currentPage = ls_data.saveAry[current_hd].randomAry[cache_q].random;

			} else { // それ以外の場合はcorrectAry上でのカレント出題IDの次の出題IDで代入
				const correctAry = ls_data.saveAry[current_hd].correctAry;
				for (i = 0; i < (correctAry.length-1); i++) {
					if (this.currentPage === correctAry[i].id) {
						this.currentPage = correctAry[i+1].id;
						break;
					}
				}
			}

			ls_data.saveAry[current_hd].current = this.currentPage;

			// 解答数と正解数を成績キャッシュ用に加算
			ls_data.saveAry[current_hd].cache.q += 1;
			if (this.data.check) {
				if (!ls_data.saveAry[current_hd].cache.a) {
					ls_data.saveAry[current_hd].cache.a = 1;
				} else {
					ls_data.saveAry[current_hd].cache.a += 1;
				}
			}

			// 次の問題を表示する際は各UI表示を初期化
			this.bool = {answer: false, active_expl: false, active_next: false, active_submit : false,  explanation: false, howto: false, confirm: false, correct: false, txtaligntop: false, show: false};
			this.data.answers = [];
			this.data.answer = "";
			this.data.select_answer = 0;
			this.data.explanation = "";
			this.data.howto = "";

			// 保存済み正解チェック情報がない場合はfalse、ある場合は取得して復旧
			if (!ls_data.saveAry[current_hd].bookmarkAry[this.currentPage]) {
				this.data.bookmark = false;
			} else if (ls_data.continueBool && this.data.continue_order) {
				for (i = 0; ls_data.saveAry[current_hd].bookmarkAry.length; i++) {
					if (ls_data.saveAry[current_hd].bookmarkAry[i].id === ls_data.saveAry[current_hd].current) {
						this.data.bookmark = ls_data.saveAry[current_hd].bookmarkAry[i].bool;
						break;
					}
				}
			} else {
				this.data.bookmark = ls_data.saveAry[current_hd].bookmarkAry[this.currentPage].bool;
			}

			// 出題登録チェック情報がない場合はfalse、ある場合は取得して復旧
			if (!ls_data.saveAry[current_hd].correctAry[this.currentPage]) {
				this.data.check = false;
			} else if (ls_data.continueBool && this.data.continue_order) {
				for (i = 0; ls_data.saveAry[current_hd].correctAry.length; i++) {
					if (ls_data.saveAry[current_hd].correctAry[i].id === ls_data.saveAry[current_hd].current) {
						this.data.check = ls_data.saveAry[current_hd].correctAry[i].bool;
						break;
					}
				}
			} else {
				this.data.check = ls_data.saveAry[current_hd].correctAry[this.currentPage].bool;
			}
			ls.setStorageJson(this.ls_key, ls_data);
			return;
		},
		// 成績結果画面へ移動
		resultPage: function() {
			var ls_data = ls.getStorageJson(this.ls_key);
			const current_hd = ls_data.current_head_id;
			ls_data.saveAry[current_hd].finishBool = true;
			// 正解数を成績キャッシュ用に加算
			if (this.data.check) {
				if (!ls_data.saveAry[current_hd].cache.a) {
					ls_data.saveAry[current_hd].cache.a = 1;
				} else {
					ls_data.saveAry[current_hd].cache.a += 1;
				}
			}

			ls_data.saveAry[current_hd].answerAry = this.multipleAnswerInputs;
			ls.setStorageJson(this.ls_key, ls_data);
			this.$router.push("/result");
			return;
		},
		checkHeader(){ //for results page
			let Q = this.Qs[this.currentPage];
			let header = (Q.header).split(' ');
			let qHeader;
			if(Q.header === 'すべてのジャンルから解く'){
				qHeader =  (Q.contents.questionHeader).split(' ');
			}
			
			if(header[0] === '数学' ||  header[0] == '英語' 
				|| (Q.header === 'すべてのジャンルから解く' && qHeader[0] === '数学')
				|| (Q.header === 'すべてのジャンルから解く' && qHeader[0] === '英語')) {

				if(this.bool.active_next){
					this.resultPage();
				}

			}else{
				this.resultPage();
			}
		},

		headerTitle(header){ //for displaying math and english subjects
			if(header){
				let hd = header.split(" ");
				let Q = this.Qs[this.currentPage];
				return hd[0];
			}
		},
		imageChecker(text){
			let ext = text.split('.').pop();
			if(ext === 'png' || ext === 'jpg'){
				return true
			}
			return false;
		},
		imageGetter(text){
			let texts = text.split("  "); //if json has image data, kindly put double spaces (ex. "text" : "Sample Image  <double space> <imgfile.png>")
			return texts;
		},
		// 解説ボタンイベント
		viewExplanation: function(currentExplanation) {
			
			let answers = this.Qs[this.currentPage].contents.answers;
		
			if (!this.bool.explanation) { //if explanation has data
				this.data.explanation = currentExplanation;
				this.bool.explanation = true;
				this.bool.active_expl = true;
				this.bool.show = false;
				
				// fw.fixedWindow(".exp_window"); // 背面スクロールを禁止（jQuery）

			} else {
				this.data.explanation = "";
				this.bool.explanation = false;
			

				if(answers.length > 0){
					this.bool.show = true;
				}else{
					this.bool.show = false;
				}
				
				// fw.releaseWindow(".exp_window"); // 背面スクロール禁止を解除
			}
			
		},
		// アプリの使い方ボタンイベント
		viewHowto: function() {
			const howto = this.SettingObj.howto;
			if (!this.bool.howto) {
				this.data.howto = howto;
				this.bool.howto = true;
				// fw.fixedWindow(".help_window");

			} else {
				this.data.howto = "";
				this.bool.howto = false;
				// fw.releaseWindow(".help_window");
			}
		},
		// 続行確認イベント
		switchConfirm: function() {
			this.bool.confirm = !this.bool.confirm;
		},
		checkAnswer: function() {
			var ls_data = ls.getStorageJson(this.ls_key);
			var current_hd = ls_data.current_head_id;

			if(!this.multipleAnswers[this.currentPage]) return;
			let Q = this.Qs[this.currentPage]
			const question = Q.contents

			const answers = [...this.multipleAnswers[this.currentPage]].sort(function(a, b){
				return a.index - b.index;
			})

			//don't allow user to submit when answers aren't completed
			/*if(Q.header === '数学' || (Q.header === 'すべてのジャンルから解く' && Q.contents.questionHeader === '数学')) {
				if(question.answer.split(" ").length !== answers.length) return;
			} else {
				if(question.answers.length !== answers.length) return;
			}*/
			
			let answer;
			var correctAns = [];

			if(this.headerTitle(Q.header) === '数学' || (Q.header === 'すべてのジャンルから解く' && this.headerTitle(Q.contents.questionHeader) === '数学')) {
				answer = answers.map(function(it){
					let ans = (it.answer).split(':');
					if(ans.length > 1){
						return ans[0]
					}
					return it.answer.replace("img:", "")
				}).join(" ");
			} else {
				answer = question.textEng.split(" ").map(function(text){
					if(!text.startsWith("b:")){
					
						correctAns.push(text);
						return text
					}
					
					let blankCount = parseInt(text.substring(2))
					let blankText = [];
					
					for(let i = 0; i < blankCount; i++) {
						if(answers[0]){ //allow user to submit even when answers aren't complete
							blankText.push(answers.splice(0, 1)[0].answer)
						}
					}
	
					return blankText.join(" ")
				}).join(" ")
			}
			
			this.fixedAnswers[this.currentPage] = correctAns;
		
			this.bool.show = true;

			this.multipleAnswerInputs[this.currentPage] = answer
			
			if(Q.contents.explanation != ""){ //if explanation has a data
				this.bool.active_expl = true;
			}
			
			this.bool.active_next = true;

			if(answer === question.answer) {
				this.bool.correct = true
			} else {
				this.bool.correct = false
			}
			//save selected answer
			ls_data.saveAry[current_hd].multiple = this.multipleAnswers;
			ls_data.saveAry[current_hd].fixed = this.fixedAnswers;
			ls.setStorageJson(this.ls_key, ls_data);
       
			this.checkMultipleCorrect(this.currentPage, this.bool.correct)
		}
	},
	
}
